// A FEJLÉC „Új…" MENÜJE — desktopon `DropdownMenu` a `ListNewButton` gradiens-stílusával (a célok és a jog-szűrés:
// `new-actions.tsx`). Mobilon ugyanezeket a célokat az `AppShell` FAB-ja viszi. Ha egy cél sincs, menü sincs.
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ListNewMenuTrigger } from '@/components/shared/list-new-button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { NEW_ACTION_ICONS, type NewAction } from '@/features/dashboard/components/new-actions';

export function NewMenu({ actions }: { actions: NewAction[] }): JSX.Element | null {
  const { t } = useTranslation();
  if (actions.length === 0) return null;
  return (
    <div className="hidden md:block">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <ListNewMenuTrigger label={t('dashboard.newMenu.label')} />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {actions.map((a) => {
            const Icon = NEW_ACTION_ICONS[a.key];
            return (
              <DropdownMenuItem key={a.key} asChild>
                <Link
                  // A típusos router-`to` szűkebb, mint a `string`; a lista adat-vezérelt (jog-szűrt), ezért cast.
                  to={a.to as never}
                  search={a.search as never}
                  className="flex items-center gap-2"
                >
                  <Icon className="text-muted-foreground size-4 shrink-0" aria-hidden />
                  {t(`dashboard.newMenu.items.${a.key}`)}
                </Link>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
